import React from 'react';
import skoolpillarLogo from '../Layouts/Authentication/parts/skoolpillar_logo.png';

const LoadingScreen: React.FC = () => {
  return (
    <div className="ls-root" role="status" aria-live="polite">
      <style>{`
        .ls-root {
          position: relative;
          height: 100vh;
          overflow: hidden;
          display: flex;
          align-items: center;
          justify-content: center;
          background: linear-gradient(180deg, #1e3a8a 0%, #2855ae 55%, #3b82f6 100%);
        }
        .ls-grain {
          position: absolute; inset: 0; pointer-events: none;
          background: repeating-linear-gradient(90deg, rgba(255,255,255,0.035) 0 1px, transparent 1px 5px);
        }
        .ls-glow {
          position: absolute; left: 50%; bottom: -30%;
          width: 90%; height: 70%; transform: translateX(-50%);
          background: radial-gradient(ellipse at 50% 85%, rgba(255,255,255,0.35) 0%, rgba(59,130,246,0.35) 35%, rgba(59,130,246,0) 70%);
          filter: blur(24px);
          animation: lsGlow 6s ease-in-out infinite alternate;
        }
        .ls-columns {
          position: absolute; left: 50%; bottom: 0;
          width: min(560px, 80%); height: 55%;
          transform: translateX(-50%);
          display: flex; align-items: flex-end;
          filter: blur(6px);
          -webkit-mask-image: linear-gradient(to top, #000 35%, transparent 100%);
                  mask-image: linear-gradient(to top, #000 35%, transparent 100%);
        }
        .ls-col {
          position: relative; overflow: hidden; flex: 1;
          height: var(--h, 70%);
          transform-origin: bottom;
          background:
            linear-gradient(90deg, rgba(255,255,255,0.22) 0%, rgba(255,255,255,0) 35%, rgba(30,58,138,0.25) 100%),
            linear-gradient(to top, #ffffff 0%, rgba(255,255,255,0.75) 12%, #3b82f6 38%, #2855ae 64%, #1e3a8a 84%, rgba(30,58,138,0) 100%);
          animation: lsRise var(--d, 5s) ease-in-out var(--delay, 0s) infinite alternate;
        }
        .ls-col::after {
          content: ''; position: absolute; left: 0; right: 0; bottom: -40%; height: 40%;
          background: linear-gradient(to top, rgba(255,255,255,0), rgba(255,255,255,0.55), rgba(255,255,255,0));
          animation: lsSweep var(--s, 4s) linear var(--delay, 0s) infinite;
        }
        .ls-col:nth-child(1) { --h: 40%;  --d: 4s;   --s: 3.2s; --delay: -1.7s; opacity: 0.75; }
        .ls-col:nth-child(2) { --h: 72%;  --d: 4.5s; --s: 3.6s; --delay: -1.2s; }
        .ls-col:nth-child(3) { --h: 100%; --d: 6s;   --s: 4.4s; --delay: -3s; }
        .ls-col:nth-child(4) { --h: 78%;  --d: 5.2s; --s: 3.9s; --delay: -0.4s; }
        .ls-col:nth-child(5) { --h: 44%;  --d: 6.8s; --s: 4.8s; --delay: -2.1s; opacity: 0.75; }

        .ls-content {
          position: relative; z-index: 2;
          display: flex; flex-direction: column; align-items: center;
          gap: 1.75rem; margin-bottom: 12vh;
          color: #fff; text-align: center;
          animation: lsFadeIn 0.5s ease-out;
        }
        .ls-logo {
          height: 4.5rem; width: auto;
          filter: brightness(0) invert(1);
          animation: lsBreathe 2.4s ease-in-out infinite;
        }
        .ls-bar {
          position: relative; overflow: hidden;
          width: 10rem; height: 3px; border-radius: 3px;
          background: rgba(255,255,255,0.18);
        }
        .ls-bar::after {
          content: ''; position: absolute; top: 0; bottom: 0; left: 0;
          width: 40%; border-radius: 3px;
          background: linear-gradient(90deg, rgba(255,255,255,0), #ffffff, rgba(255,255,255,0));
          animation: lsSlide 1.3s ease-in-out infinite;
        }
        .ls-text {
          margin: 0; font-size: 0.8rem; font-weight: 600;
          letter-spacing: 0.18em; text-transform: uppercase;
          color: rgba(255,255,255,0.72);
        }

        @keyframes lsRise {
          0%   { transform: scaleY(0.68); filter: brightness(0.9); }
          55%  { transform: scaleY(1.05); filter: brightness(1.12); }
          100% { transform: scaleY(0.82); filter: brightness(1); }
        }
        @keyframes lsSweep {
          from { transform: translateY(0); opacity: 0; }
          15%  { opacity: 1; }
          85%  { opacity: 1; }
          to   { transform: translateY(-350%); opacity: 0; }
        }
        @keyframes lsGlow {
          from { opacity: 0.75; }
          to   { opacity: 1; }
        }
        @keyframes lsBreathe {
          0%, 100% { opacity: 1; transform: scale(1); }
          50%      { opacity: 0.8; transform: scale(0.97); }
        }
        @keyframes lsSlide {
          from { transform: translateX(-100%); }
          to   { transform: translateX(250%); }
        }
        @keyframes lsFadeIn {
          from { opacity: 0; transform: translateY(10px); }
          to   { opacity: 1; transform: translateY(0); }
        }

        @media (max-width: 768px) {
          .ls-logo { height: 3.25rem; }
          .ls-columns { height: 40%; opacity: 0.85; }
        }
        @media (prefers-reduced-motion: reduce) {
          .ls-col, .ls-col::after, .ls-glow, .ls-logo { animation: none; }
          .ls-bar::after { animation-duration: 2.5s; }
        }
      `}</style>

      <div className="ls-grain" aria-hidden="true" />
      <div className="ls-glow" aria-hidden="true" />
      <div className="ls-columns" aria-hidden="true">
        <span className="ls-col" />
        <span className="ls-col" />
        <span className="ls-col" />
        <span className="ls-col" />
        <span className="ls-col" />
      </div>

      <div className="ls-content">
        <img className="ls-logo" src={skoolpillarLogo} alt="SkoolPillar" />
        <div className="ls-bar" />
        <p className="ls-text">Loading</p>
      </div>
    </div>
  );
};

export default LoadingScreen;